import React, { useState, useEffect } from "react";
import NumberFormat from "react-number-format";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import { getItemPrices } from "../../../../services/sales/salesService";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
function SearchItemPrice({
  customerID = 0,
  leadID = 0,
  itemID = 0,
  varCode = "-",
  onSelectItemPrice,
}) {
  const { reload } = useGlobalData();
  const { companyProfile } = useGlobalData();
  const [itemPrices, setItemPrice] = useState();
  useEffect(() => {
    getItemPricesData(customerID, leadID, itemID, varCode);
  }, [customerID, leadID, itemID, varCode, reload]);
  return (
    <CustomDataTableSearch
      data={itemPrices}
      onRefreshData={() => {
        getItemPricesData(customerID, leadID, itemID);
      }}
      onSelectedData={(rowData, originalEvent) => {
        onSelectItemPrice(rowData);
      }}
      columns={[
        {
          field: "select",
          body: (rowData) => (
            <React.Fragment>
              <button
                type="button"
                className="btn btn-label-success btn-sm btn-pill btn-bold"
                onClick={() => onSelectItemPrice(rowData)}
              >
                Select <i className="fas fa-angle-double-right"></i>
              </button>
            </React.Fragment>
          ),
        },
        {
          header: "Customer Group",
          field: "customerGroup.groupName",
          body: (rowData) => (
            <React.Fragment>
              <ResponsiveEllipsis
                text={rowData.customerGroup.groupName}
                maxLine="1"
              />
            </React.Fragment>
          ),
          sortable: true,
        },
        {
          header: "Variant Name",
          field: "variantName",
          body: (rowData) => (
            <React.Fragment>
              <ResponsiveEllipsis text={rowData.variantName} maxLine="1" />
            </React.Fragment>
          ),
          body: null,
          sortable: true,
        },
        {
          header: "Unit",
          field: "uomName",
          body: (rowData) => (
            <React.Fragment>
              <ResponsiveEllipsis text={rowData.uomName} maxLine="1" />
            </React.Fragment>
          ),
          sortable: true,
        },
        {
          header: "Currency",
          field: "currency.currencyCode",
          body: null,
          sortable: true,
          hidden: true,
        },
        {
          header: "Price",
          field: "price",
          body: (rowData) => (
            <NumberFormat
              value={rowData.price}
              displayType={"text"}
              thousandSeparator={true}
              decimalScale={2}
              renderText={(value) => (
                <div className="float-right">
                  {companyProfile.currency.currencyCode} {value}
                </div>
              )}
            />
          ),
          sortable: true,
        },
      ]}
    />
  );
  async function getItemPricesData(
    customerID = 0,
    leadID = 0,
    itemID = 0,
    varCode = "-"
  ) {
    if (varCode === "") {
      varCode = "-";
    }
    const response = await getItemPrices(customerID, leadID, itemID, varCode);
    const { data } = response.data;
    setItemPrice(data.itemPrices);
  }
}

export default SearchItemPrice;
